import ImmutabilityForEveryone from './ImmutabilityForEveryone.vue';
import NewOotbis from './NewOotbis.vue';
import ConsumptionModel from './ConsumptionModel.vue';
import CasesPromo from './CasesPromo.vue';

export default {
  ImmutabilityForEveryone,
  NewOotbis,
  ConsumptionModel,
  CasesPromo,
};
